import styled from "styled-components";

export const AddressRow = styled.div`
  display: ${props => props.theme.address?.display || 'flex'};
  gap: ${props => props.theme.horizontalFieldGap || '5px'};

  > * {
    flex: 2;

    &:first-child {
      flex: 3;
    }
  }
`;

export const StyledAddressLabel = styled.div`
  display: ${props => props.theme.address?.labelDisplay};
`;

export const HouseNumberRow = styled.div`
  display: flex;
  gap: ${props => props.theme.horizontalFieldGap || '5px'};
  > * {
    flex: 1;
  }
`;

export const FoundAddress = styled.div`
  margin-top: ${props => props.theme.horizontalFieldGap};
  color: ${props => props.theme.address?.foundAddressColor};
`;

export const FoundAddressTitle = styled.div`
  display: ${props => props.theme.address?.foundAddressLabelDisplay || 'none'};
  font-weight: ${props => props.theme.address?.foundAddressLabelWeight};
`;

export const NoFoundAddress = styled.div`
  display: ${props => props.theme.address?.noFoundAddressDisplay || 'none'};
`;
